import clsx from "clsx";

/**
 * Material Symbols (https://fonts.google.com/icons) を SVG で `apps/webapp/public/i/dx/` に
 * 配置し、CSS の `mask-image` + `background-color: currentColor` で着色する。これにより
 * `text-dx-*` のような Tailwind 文字色クラスで色テーマを継承できる。
 *
 * SVG 自体は viewBox `0 -960 960 960` の Material Symbols 仕様で、`fill` は使わない
 * (mask は alpha のみを利用する)。サイズは 20×20 をデフォルトとする。
 */
export function DxIcon({
  src,
  className,
}: {
  src: string;
  className?: string;
}) {
  return (
    <span
      aria-hidden
      className={clsx("block size-[20px] shrink-0 bg-current", className)}
      style={{
        WebkitMaskImage: `url(${src})`,
        maskImage: `url(${src})`,
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
        WebkitMaskSize: "contain",
        maskSize: "contain",
        WebkitMaskPosition: "center",
        maskPosition: "center",
      }}
    />
  );
}

export function CloseIcon({ className }: { className?: string }) {
  return <DxIcon src="/i/icon_close.svg" className={className} />;
}

export function HourglassIcon({ className }: { className?: string }) {
  return <DxIcon src="/i/dx/hourglass.svg" className={className} />;
}
